exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".color-text {\n    font-size: 13px;\n    width: 70px;\n    padding: 0 2px;\n  }\n  ", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /app/src/app/layout/speaker-select/speaker-select.component.css
// module id = ../../../../../src/app/layout/speaker-select/speaker-select.component.css
// module chunks = main